<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/receivableList' }">应收</el-breadcrumb-item>
                <el-breadcrumb-item>应收{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'el-select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-select
                                        v-model="formData[item.prop]"
                                        filterable
                                        clearable
                                        multiple
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                    >
                                        <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    v-show="
                                        is_admin ||
                                        !in_array(item['prop'], [
                                            'unit_standard_cost',
                                            'unit_sales_standard_cost',
                                            'unit_sales_standard_cost_taxincluded_'
                                        ])
                                    "
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNumber } from '@/js/common.js';

export default {
    name: 'receivableEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {}, // 表单验证信息
            options: [],
            is_admin: false
        };
    },
    created() {
        this.type = this.$route.query.type;

        let roles = JSON.parse(localStorage.getItem('roles'));
        if (roles != null && in_array(process.env.VUE_APP_ADMIN_ROLE_ID, roles)) {
            this.is_admin = true;
        } else {
            this.is_admin = false;
        }

        this.$api['dropdownReceivableLockSign']({})
            .then((res) => {
                if (res.code == 0) {
                    this.options = res.data;
                    this.initFormData();
                }
            })
            .catch((error) => {});

        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        }
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                business_unit_code: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '业务单元',
                    ref: 'business_unit_code_ref',
                    type: 'dropdown',
                    select_value: 'code',
                    tips: '非必填，默认从绩效单元截取'
                },
                performance_unit_code: {
                    request_uri: 'dropdownPerformanceUnit',
                    title: '绩效单元',
                    ref: 'performance_unit_code_ref',
                    type: 'dropdown',
                    request_params: { is_leaf: true },
                    select_value: 'code',
                    tips: '非叶子节点或23年以前的绩效单元，无法显示'
                },
                lock_sign: {
                    title: '锁定标签',
                    ref: 'lock_sign_ref',
                    type: 'el-select',
                    tips: '可多选'
                }
            };
        },
        initFormRule() {
            this.rules = {
                unit_standard_cost: { required: true, validator: checkNumber, trigger: 'blur' }, // 单位生产成本
                unit_sales_standard_cost: { required: true, validator: checkNumber, trigger: 'blur' }, // 单位销售成本
                unit_sales_standard_cost_taxincluded_: { required: true, validator: checkNumber, trigger: 'blur' }, // 单位含税销售成本
                business_unit_code: [{ required: false, message: '业务单元(非必填)', trigger: 'blur' }],
                performance_unit_code: [{ required: false, message: '绩效单元', trigger: 'blur' }],
                lock_sign: [{ required: false, message: '锁定标签', trigger: 'blur' }]
            };
        },

        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                business_unit_code: this.data.business_unit_code || '',
                performance_unit_code: this.data.performance_unit_code || '',
                lock_sign: this.data.lock_sign_array || [],
                unit_standard_cost: this.data.unit_standard_cost || '0',
                unit_sales_standard_cost: this.data.unit_sales_standard_cost || '0',
                unit_sales_standard_cost_taxincluded_: this.data.unit_sales_standard_cost_taxincluded_ || '0'
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).receivable;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['lock_sign', 'unit_standard_cost', 'unit_sales_standard_cost', 'unit_sales_standard_cost_taxincluded_']
                },
                {
                    business_unit_name: 'business_unit_code',
                    performance_unit_name: 'performance_unit_code'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'receivableList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .receivableDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'receivableUpdate';
            } else {
                uri = 'receivableInsert';
            }

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>